<template>
  <div>
    <vs-popup :title="skill" :active.sync="detailPrompt" v-on:click="showTodoPrompt" style="z-index:530001" >
      <div class="flex justify-between items-center mb-4">
          <span class="flex justify-between items-center">
            <span class="text-warning font-semibold">{{attribute}} </span>
            <vs-chip class="mx-2 modern-status-chip">
                <span>{{ status==='wip'?$t("todo.lbl0_opt0"):status==='todo'?$t("todo.lbl0_opt2"):$t("todo.lbl0_opt1") | capitalize }}</span>
            </vs-chip>
          </span>
        <div class="flex sm:justify-end">
          <feather-icon v-if="status!=='wip'" icon="ArrowRightIcon" class="cursor-pointer text-primary w-5 h-5 mx-2 hover:scale-110 transition" @click.stop="updateStatus(id,'wip')" />
          <feather-icon v-if="status!=='done'" icon="CheckIcon" class="cursor-pointer text-success w-5 h-5 mx-2 hover:scale-110 transition" @click.stop="updateStatus(id,'done')" />
          <feather-icon v-if="status!=='todo'" icon="TrashIcon" class="cursor-pointer text-danger w-5 h-5 mx-2 hover:scale-110 transition" @click.stop="updateStatus(id,'todo')" />
        </div>
      </div>
      <div class="con-example-prompt text-lg text-gray-700">
        {{fullDevelopmentAction}}
      </div>
    </vs-popup>
    
    <!-- Use computed filteredAndSortedTasks instead of raw tasks -->
    <div v-for="task in filteredAndSortedTasks" :key="task.id" >
      <div v-if="filter === 'all' || filter === task.status" class="px-5 py-4 list-item-component modern-card" :class="task.status">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-2/3 flex sm:items-center sm:flex-row flex-col">
            <div class="vx-col w-full text-base font-medium text-gray-800" v-if="companyName==='Deep' || companyName==='PCI'">
              <p class="mt-2 cursor-pointer hover:text-primary transition" @click="displayDetailPrompt(task.da[0].da || task.da,task.skill,task.attri,task.id,task.status)">{{ task.da[0].da || task.da }}</p>
            </div>
            <div class="vx-col w-full text-base font-medium text-gray-800" v-else>
              <p class="mt-2 cursor-pointer hover:text-primary transition" @click="displayDetailPrompt(task.da,task.skill,task.attri,task.id,task.status)">{{ task.da }}</p>
            </div>
          </div>
          
          <div class="vx-col w-full sm:w-1/3 ml-auto flex sm:justify-end items-center mt-2 sm:mt-0">
            <div class="todo-tags flex flex-wrap gap-2 justify-end">
              <vs-chip class="modern-skill-chip">
                <span>{{task.skill | capitalize }}</span>
              </vs-chip>
              <vs-chip class="modern-attribute-chip">
                <span>{{ task.attri | capitalize }}</span>
              </vs-chip>
            </div>
          </div>
        </div>
        
        <div class="vx-row mt-4 items-center">
          <vs-chip class="modern-status-chip ml-2">
            <span>{{ task.status==='wip'?$t("todo.lbl0_opt0"):task.status==='todo'?$t("todo.lbl0_opt2"):$t("todo.lbl0_opt1") | capitalize }}</span>
          </vs-chip>
          
          <div class="vx-col w-full sm:w-auto ml-auto flex sm:justify-end items-center space-x-2">
            <feather-icon v-if="task.status!=='wip'" icon="ArrowRightIcon" class="cursor-pointer modern-icon icon-primary" @click.stop="updateStatus(task.id,'wip')" title="Move to Doing"/>
            <feather-icon v-if="task.status!=='done'" icon="CheckIcon" class="cursor-pointer modern-icon icon-success" @click.stop="updateStatus(task.id,'done')" title="Mark Done"/>
            <feather-icon v-if="task.status!=='todo'" icon="TrashIcon" class="cursor-pointer modern-icon icon-danger" @click.stop="updateStatus(task.id,'todo')" title="Move to Trashed"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";
import baseData from "@/i18n/i18n-en-Data-DPM.js";           
import deepData from "@/i18n/i18n-en-deep-Data.js";       
import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";         
import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js"; 

export default{
  props: {
    taskId: {
      type: Number,
      required: true
    },
    compId: {
      type: String,
      required: true
    },
    filter: {
      type: String,
      required: true
    },
    // NEW PROP: Accepts search query from parent
    searchQuery: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      detailPrompt: false,
      CCD: this.$t("addNewSkill.data"),
      tasks: [],
      companyName:"",
      fullDevelopmentAction: '',
      skill: '',
      attribute: '',
      status: '',
      id: ''
    }
  },
  computed: {
    todoLabelColor () {
      return (label) => {
        const tags = this.$store.state.todo.taskTags
        return tags.find((tag) => {
          return tag.value === label
        }).color
      }
    },
    // Handles Real-time Search Filtering and Descending Sorting
    filteredAndSortedTasks() {
      let result = this.tasks;
      
      // 1. If user typed in search bar, filter the list
      if (this.searchQuery && this.searchQuery.trim() !== '') {
        const query = this.searchQuery.toLowerCase().trim();
        result = result.filter(task => {
          
          // OLDER JS SAFE CHECK (No Optional Chaining)
          let taskString = '';
          if (typeof task.da === 'string') {
            taskString = task.da;
          } else if (task.da && task.da.length > 0 && task.da[0].da) {
            taskString = task.da[0].da;
          }
          
          const taskText = taskString.toLowerCase();
          const skillText = (task.skill || '').toLowerCase();
          const attrText = (task.attri || '').toLowerCase();
          
          return taskText.includes(query) || skillText.includes(query) || attrText.includes(query);
        });
      }
      
      // 2. Sort explicitly by ID descending (newest top)
      return result.sort((a, b) => b.id - a.id);
    }
  },
  methods: {
    showTodoPrompt(){
      this.$emit('todoPrompt');
    },
    updateStatus (id,status) {
      const data = { id : id, status: status }
      this.$store.dispatch('developmentActions/updateDA', data)
        .then((response) => {
          this.$vs.notify({ title: i18n.t('notification.user.todo.update.success.u1'), text:  i18n.t('notification.user.todo.update.success.u2'), color: "primary" });
          this.fetchDA();
          this.status = status;
        }).catch((error) => {
          this.$vs.notify({ title: i18n.t('notification.user.todo.update.failed.u1'), text:  i18n.t('notification.user.todo.update.failed.u2'), color: "danger" });
        })
    },
    displayPrompt () { this.$emit('detailPrompt', this.developmentAction) },
    displayDetailPrompt(da,sk,at,id,status){
      this.fullDevelopmentAction = da; this.skill = sk; this.attribute = at; this.id = id; this.status = status; this.detailPrompt = true;
    },
    fetchDA() {
      if(window.$cookies.get('companyName')==='Deep' || window.$cookies.get('companyName')==='PCI') {
        this.$store.dispatch('developmentActions/fetchDA', {query: {traineeCompetenciesId: this.taskId}}).then(res => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].developmentActionId.includes('custom_da')) {
              const daID = res.data[i].developmentActionId.split('-');
              res.data[i]['skill'] = this.CCD[daID[0]] ? this.CCD[daID[0]].characteristic : 'Unknown Skill';
              res.data[i]['attri'] = (this.CCD[daID[0]] && this.CCD[daID[0]].competencies[daID[1]]) ? this.CCD[daID[0]].competencies[daID[1]].comp : 'Unknown Attribute';
              res.data[i]['da'] = res.data[i].developmentAction;
              res.data[i]['id'] = res.data[i].id;
            } else {
              const daID = res.data[i].developmentActionId.split('-');
              res.data[i]['skill'] = this.CCD[daID[0]] ? this.CCD[daID[0]].characteristic : 'Unknown Skill';
              res.data[i]['attri'] = (this.CCD[daID[0]] && this.CCD[daID[0]].competencies[daID[1]]) ? this.CCD[daID[0]].competencies[daID[1]].comp : 'Unknown Attribute';
              res.data[i]['da'] = (this.CCD[daID[0]] && this.CCD[daID[0]].competencies[daID[1]] && this.CCD[daID[0]].competencies[daID[1]].progressMeasures[daID[2]]) ? this.CCD[daID[0]].competencies[daID[1]].progressMeasures[daID[2]].developmentActions : 'Unknown Task';
              res.data[i]['id'] = res.data[i].id;
            }
          }
          this.tasks = res.data;
        }).catch(err => console.error("Error fetching DA:", err))
      } else {
        this.$store.dispatch('developmentActions/fetchDA', {query: {traineeCompetenciesId: this.taskId}}).then(res => {
          const allFrameworks = [{ name: 'Base', data: baseData }, { name: 'Deep', data: deepData }, { name: 'PCI', data: pciData }, { name: 'PeopleTree', data: peopletreeData }];
          const formattedTasks = res.data.map(item => {
            let finalTaskName = "Unknown Task", finalSkillName = "Unknown Skill", finalAttriName = "Unknown Attribute";
            try {
              let chId, coId, daId, baseActionId;
              let isCustom = item.developmentActionId.includes('custom_da');
              let searchId = item.developmentActionId;

              if (isCustom) {
                const daParts = (this.compId || "custom-da").split('-');
                chId = daParts[0]; coId = daParts[1];
              } else {
                baseActionId = item.developmentActionId.split(':')[0]; 
                const daParts = baseActionId.split("-");
                chId = daParts[0]; coId = daParts[1]; daId = daParts[2];
              }

              for (let i = 0; i < allFrameworks.length; i++) {
                let fwRaw = allFrameworks[i].data;
                if(fwRaw && fwRaw.default) fwRaw = fwRaw.default;
                let fwData = (fwRaw && fwRaw.addNewSkill && fwRaw.addNewSkill.data) ? fwRaw.addNewSkill.data : fwRaw;
                let tempSkill = "Unknown Skill", tempAttri = "Unknown Attribute", tempTask = "Unknown Task";

                if (fwData && fwData[chId]) {
                  tempSkill = fwData[chId].characteristic || "Unknown Skill";
                  if (fwData[chId].competencies && fwData[chId].competencies[coId]) {
                    let compData = fwData[chId].competencies[coId];
                    tempAttri = compData.comp || "Unknown Attribute";
                    if (isCustom) {
                      tempTask = item.developmentAction || "Custom Task";
                    } else {
                      if (compData.developmentActions && Array.isArray(compData.developmentActions)) {
                        let match = compData.developmentActions.find(x => x.id === searchId || x.id === baseActionId);
                        if (match) tempTask = match.da;
                      }
                      if (tempTask === "Unknown Task" && daId && compData.progressMeasures && compData.progressMeasures[daId]) {
                         let pmData = compData.progressMeasures[daId].developmentActions;
                         if (Array.isArray(pmData)) {
                             let match = pmData.find(x => x.id === searchId || x.id === baseActionId);
                             if (match) tempTask = match.da;
                             else if (pmData.length > 0 && pmData[0].da) tempTask = pmData[0].da;
                         } else if (typeof pmData === 'string') tempTask = pmData;
                      }
                    }
                  }
                }
                if (tempTask !== "Unknown Task") {
                   finalSkillName = tempSkill; finalAttriName = tempAttri; finalTaskName = tempTask; break; 
                } else if (tempSkill !== "Unknown Skill" && finalSkillName === "Unknown Skill") {
                   finalSkillName = tempSkill; finalAttriName = tempAttri;
                }
              }
              if (finalTaskName === "Unknown Task" && item.developmentAction) finalTaskName = item.developmentAction;
            } catch (error) { console.warn("Error parsing IDs for task:", item, error); }

            return { ...item, id: item.id, skill: finalSkillName, attri: finalAttriName, da: finalTaskName };
          });
          this.tasks = formattedTasks;
        }).catch(err => console.error("Error fetching DA:", err))
      }
    }
  },
  created() {
    this.companyName=window.$cookies.get('companyName');
    this.fetchDA()
  }
}
</script>

<style lang="scss">
  /* --- COMPLETELY FLAT UI --- */
  
  .modern-card {
    background: #ffffff !important;
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important; 
    box-shadow: none !important; /* COMPLETELY kills the weird default shadow */
    margin-bottom: 0.85rem;
    transition: all 0.2s ease-in-out;
    
    &:hover {
      box-shadow: none !important; /* Ensures NO shadow on hover either */
      border-color: #cbd5e1 !important; /* Slightly darker border on hover */
      background-color: #f8fafc !important; /* Very subtle grey background on hover instead of shadow */
    }
  }

  .modern-skill-chip {
    background-color: #ecfdf5 !important;
    border: 1px solid #a7f3d0 !important;
    span { color: #047857 !important; font-weight: 600; font-size: 0.75rem;}
  }

  .modern-attribute-chip {
    background-color: #f5f3ff !important;
    border: 1px solid #ddd6fe !important;
    span { color: #6d28d9 !important; font-weight: 600; font-size: 0.75rem;}
  }
  
  .modern-status-chip {
    background-color: #f3f4f6 !important;
    border: 1px solid #e5e7eb !important;
    span { color: #4b5563 !important; font-weight: 600; font-size: 0.75rem;}
  }

  .modern-icon {
    width: 22px;
    height: 22px;
    padding: 3px;
    border-radius: 6px;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #e5e7eb;
    }
    
    &.icon-primary { color: #3b82f6; }
    &.icon-success { color: #10b981; }
    &.icon-danger { color: #ef4444; }
  }
</style>